export default __webpack_public_path__ + "static/media/completeIcon.76c35355.svg";